/** Stati UI tab Controllo mensile */
export const STATO_FATTURA_CONTROLLO = {
  bozza: { label: "Bozza", className: "bg-slate-100 text-slate-700" },
  da_verificare: { label: "Da verificare", className: "bg-orange-100 text-orange-800" },
  approvata: { label: "Approvata", className: "bg-violet-100 text-violet-800" },
  in_coda_sdi: {
    label: "In coda SDI",
    className: "bg-sky-100 text-sky-800 ring-1 ring-sky-200",
    spinning: true,
  },
  inviata_sdi: { label: "Inviata (SDI)", className: "bg-emerald-100 text-emerald-800" },
  scartata_sdi: { label: "Scartata SDI", className: "bg-slate-200 text-slate-600" },
  mancante: { label: "Mancante", className: "bg-red-100 text-red-800" },
};

export const STATO_PAGAMENTO_CONTROLLO = {
  pagata: { label: "Pagata", className: "bg-emerald-100 text-emerald-800" },
  da_incassare: { label: "Da incassare", className: "bg-orange-100 text-orange-800" },
  scaduta: { label: "Scaduta", className: "bg-red-100 text-red-800" },
};

export const FILTRO_STATO_CONTROLLO = [
  { value: "__tutti__", label: "Tutti gli stati" },
  { value: "mancante", label: "Mancante" },
  { value: "bozza", label: "Bozza" },
  { value: "da_verificare", label: "Da verificare" },
  { value: "approvata", label: "Approvata" },
  { value: "in_coda_sdi", label: "In coda SDI" },
  { value: "inviata_sdi", label: "Inviata (SDI)" },
  { value: "scartata_sdi", label: "Scartata SDI" },
];

export function currentMonthValue() {
  const d = new Date();
  return `${d.getFullYear()}-${String(d.getMonth() + 1).padStart(2, "0")}`;
}

export function filterRigheControllo(righe, { filtroStato, filtroFascicolo, searchQuery, soloMancanti }) {
  let list = [...(righe || [])];
  if (soloMancanti) {
    list = list.filter((r) => r.stato_fattura === "mancante");
  }
  if (filtroStato && filtroStato !== "__tutti__") {
    list = list.filter((r) => r.stato_fattura === filtroStato);
  }
  if (filtroFascicolo && filtroFascicolo !== "__tutti__") {
    list = list.filter((r) => r.fascicolo_id === filtroFascicolo);
  }
  const q = (searchQuery || "").trim().toLowerCase();
  if (q) {
    list = list.filter(
      (r) =>
        (r.ospite || "").toLowerCase().includes(q) ||
        (r.camera || "").toLowerCase().includes(q),
    );
  }
  return list;
}
